import { render, staticRenderFns } from "./custom-shopname.vue?vue&type=template&id=74d900b7"
import script from "./custom-shopname.vue?vue&type=script&lang=ts"
export * from "./custom-shopname.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports